<template>
    <Card :title="$t('labels.edit_user')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6">
                    <FormGroup :label="$t('labels.email')">
                        <Input readonly :model-value="projectUser?.email" />
                    </FormGroup>
                </div>
                <div class="col-lg-6">
                    <FormGroup :label="$t('labels.user')">
                        <Input readonly :model-value="getFullName(projectUser?.user)" />
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton @click="deleteProjectUser" color="danger" :disabled="projectUser?.type === 'creator'">
                {{ $t('buttons.delete') }}
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../../components/new/CardComponent.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';
import AppButton from '../../../../../components/new/button/AppButton.vue';

import { httpClient } from '../../../../../services/HttpClient';
import MessageNotificator from '../../../../../services/MessageNotificator';

export default {
    name: "EditProjectUsersPage",
    components: {
        Card, FormGroup, Input, AppButton
    },
    data() {
        return {
            projectUser: null
        };
    },
    methods: {
        fetchProjectUser() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/users/${this.$route.params.projectUserUuid}`)
                .then(response => {
                    this.projectUser = response.data.data;
                });
        },
        getFullName(user) {
            if (!user) return '';
            return user.full_name;
        },
        deleteProjectUser() {
            new MessageNotificator().confirm(
                this.$t('alerts.confirm_delete_user_from_project'),
                () => {
                    httpClient.delete(`/projects/${this.$route.params.projectUuid}/users/${this.$route.params.projectUserUuid}`)
                        .then(() => {
                            this.$router.replace({ name: 'IndexProjectUsersPage'});
                        });
                }
            )
        }
    },
    mounted() {
        this.fetchProjectUser();
    }
}
</script>